module.exports = __webpack_public_path__ + "img/newpinterest.e759ee96.svg";